import i18n from 'modules/core/lib/i18n'

export const getMedicalReason = (type: string) => {
  switch (type) {
    case 'absence':
      return i18n.t('time_off.medical_leave.discharge_reason.reasons.absence')
    case 'death':
      return i18n.t('time_off.medical_leave.discharge_reason.reasons.death')
    case 'healing':
      return i18n.t('time_off.medical_leave.discharge_reason.reasons.healing')
    case 'improvement':
      return i18n.t('time_off.medical_leave.discharge_reason.reasons.improvement')
    case 'inss_control_12_months':
      return i18n.t('time_off.medical_leave.discharge_reason.reasons.inss_control_12_months')
    case 'maternity_start':
      return i18n.t('time_off.medical_leave.discharge_reason.reasons.maternity_start')
    case 'medical_discharge_in_inss':
      return i18n.t('time_off.medical_leave.discharge_reason.reasons.medical_discharge_in_inss')
    case 'medical_inspection':
      return i18n.t('time_off.medical_leave.discharge_reason.reasons.medical_inspection')
    case 'permanent_disability_proposal':
      return i18n.t('time_off.medical_leave.discharge_reason.reasons.permanent_disability_proposal')
    case 'recovery_professional_capacity':
      return i18n.t(
        'time_off.medical_leave.discharge_reason.reasons.recovery_professional_capacity'
      )
    case 'term_exhaustion':
      return i18n.t('time_off.medical_leave.discharge_reason.reasons.term_exhaustion')
    default:
      throw new Error(`Unknown translation for type: ${type}`)
  }
}
